export class Tenor{
  id: number;
  workflowId: number;
  subject: string;
  body: string;
  createAt: string;
  active: number;
  deleted: number;
  observation: string;
}
